module.exports = __webpack_public_path__ + "static/media/cesar.39e817ac.png";